import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrorKey } from '../../../types/validation-error.type';

@Pipe({
  name: 'validationError',
  standalone: true,
})
export class ValidationErrorPipe implements PipeTransform {
  transform(value: unknown | null, errorKey: string): string | undefined {
    if (typeof value === 'object' && !!value) {
      const errorValue = value as Record<string, string>;
      if (errorKey === ValidationErrorKey.Min) {
        return errorValue['min'];
      }

      if (errorKey === ValidationErrorKey.Max) {
        return errorValue['max'];
      }

      if (errorKey === ValidationErrorKey.MinLength || errorKey === ValidationErrorKey.MaxLength) {
        return errorValue['requiredLength'];
      }

      return errorValue[errorKey];
    }

    return '';
  }
}
